// English strings (source language): real-time client (game server).

const en = {
  reconnecting: 'Connection lost. Reconnecting…',
  cannotReach: 'Unable to connect right now. Check your connection and try again.',
};
export default en;
